import {
  useHovercardStoreOptions,
  useHovercardStoreProps
} from "../__chunks/LDICFO4C.js";
import "../__chunks/3PKTK2K7.js";
import "../__chunks/WC3GK4CL.js";
import "../__chunks/SWJ5EOOS.js";
import {
  useStore,
  useStoreProps
} from "../__chunks/P63NRZ4A.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/tooltip/tooltip-store.ts
import * as Core from "@ariakit/core/tooltip/tooltip-store";
function useTooltipStoreOptions(props) {
  return useHovercardStoreOptions(props);
}
function useTooltipStoreProps(store, props) {
  store = useHovercardStoreProps(store, props);
  useStoreProps(store, props, "type");
  useStoreProps(store, props, "skipTimeout");
  return store;
}
function useTooltipStore(props = {}) {
  const options = useTooltipStoreOptions(props);
  const store = useStore(
    () => Core.createTooltipStore(__spreadValues(__spreadValues({}, props), options))
  );
  return useTooltipStoreProps(store, props);
}
export {
  useTooltipStore,
  useTooltipStoreOptions,
  useTooltipStoreProps
};
